"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SapporoBannerAd_1 = __importDefault(require("./SapporoBannerAd"));
const native_base_1 = require("native-base");
const about = require('./about.json');
const About = ({ getUIComponents, getImage, getMarkdown }) => {
    const UI = getUIComponents();
    return (react_1.default.createElement(native_base_1.Box, { flex: 1, alignContent: 'center', justifyContent: 'center', pb: 5, pl: 5, bg: UI.background },
        react_1.default.createElement(native_base_1.Center, { bg: UI.background },
            react_1.default.createElement(native_base_1.Heading, { pb: 3, pt: 3, size: "lg", color: "white", fontFamily: 'Montserrat' }, "About Sapporo")),
        react_1.default.createElement(native_base_1.VStack, { rounded: "lg", m: 3, p: 3, flex: 1, bg: "white" },
            react_1.default.createElement(native_base_1.ScrollView, null, getMarkdown(about.body))),
        react_1.default.createElement(SapporoBannerAd_1.default, { location: "about" })));
};
// <Center p={3}>
//<Image
//  alt="SapporoGuard Logo"
//  source={getImage('badge')}
//  size="lg"
// />
// </Center>
exports.default = About;
